import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const OutpatientConversionFactorEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (value: string) => {
    if (!contract) return;

    // Parse the value - allow empty strings and invalid numbers to pass through
    const numericValue = value === '' ? 0 : parseFloat(value);
    
    // Update Redux with the numeric value (0 for empty) but only if it's valid or empty
    if (value === '' || (!isNaN(numericValue) && isFinite(numericValue))) {
      dispatch(updateSelectedContract({
        medicareBasedConfig: {
          ...contract.medicareBasedConfig,
          outpatientConversionFactor: numericValue
        }
      }));
    }
  };

  if (!contract) return null;

  // Hide the field if "Based on Medicare" is not checked
  if (!contract.medicareBasedConfig?.basedOnMedicare) {
    return null;
  }

  const currentValue = contract.medicareBasedConfig?.outpatientConversionFactor ?? 0;

  return (
    <TextField
      label="Outpatient Conversion Factor"
      value={currentValue === 0 ? '' : currentValue}
      onChange={(e) => handleChange(e.target.value)}
      type="number"
      inputProps={{
        step: 0.01,
        min: 0
      }}
      fullWidth
      size="small"
      variant="outlined"
    />
  );
};

export default OutpatientConversionFactorEditor;